import { NextPage } from 'next';

import { SignUp } from '~/modules/auth/pages/SignUp';

import { withAuthentication } from '~/shared/utils/withAuthentication';

export const getServerSideProps = withAuthentication();

const SignUpPage: NextPage = () => {
  return <SignUp />;
};

export default SignUpPage;
